/**
 * Store reactivo del paso actual del recorrido.
 * Ver docs/SPEC-IMPLEMENTACION.md §4.1.
 */

import { writable, derived, type Readable } from 'svelte/store';
import type { PasoId } from '@/types';

/** Orden secuencial de los pasos. */
export const ORDEN_PASOS: readonly PasoId[] = [
  'INICIO',
  'SOL',
  'MUSICA',
  'LUCIERNAGAS',
  'GIRASOLES',
  'AMANECER',
  'CARTA',
] as const;

export const PASO_INICIAL: PasoId = 'INICIO';

const pasoInicial: PasoId = PASO_INICIAL;

/** Store interno del paso actual. */
const storeInterno = writable<PasoId>(pasoInicial);

/** Suscripción al paso actual. */
export const pasoActual: Readable<PasoId> = { subscribe: storeInterno.subscribe };

/** Obtiene el paso actual (síncrono). */
export function obtenerPasoActual(): PasoId {
  let actual: PasoId = pasoInicial;
  storeInterno.subscribe((v) => (actual = v))();
  return actual;
}

/** Avanza al siguiente paso del recorrido. Si ya está en el último, no hace nada. */
export function siguientePaso(): void {
  storeInterno.update((actual) => {
    const indice = ORDEN_PASOS.indexOf(actual);
    if (indice < 0 || indice >= ORDEN_PASOS.length - 1) {
      return actual;
    }
    const siguiente = ORDEN_PASOS[indice + 1];
    return siguiente ?? actual;
  });
}

/** Reinicia al paso inicial. Usado por el botón final (paso 7). */
export function reiniciarPasos(): void {
  storeInterno.set(pasoInicial);
}

/** Store derivado: índice numérico del paso actual (0-based). Útil para mostrar progreso. */
export const indiceActual = derived(storeInterno, ($actual) =>
  ORDEN_PASOS.indexOf($actual)
);
